<script>
import {
  defineComponent,
  ref,
  onMounted,
  onActivated,
  onDeactivated,
  nextTick,
} from "vue";
export default defineComponent({
  props: {
    columns: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const scrollTop = ref(0);

    //utils
    const headerCellStyle = () => {
      return {
        color: "rgba(0,0,0,.85)",
        backgroundColor: "#fafafa",
      };
    };
    const slots = {
      empty: () => {
        return <el-empty description=" " />;
      },
    };

    const tableRef = ref(null);

    const scrollFunc = () => {
      let bodyWrapper = tableRef.value.$refs.bodyWrapper.getElementsByClassName(
        "el-scrollbar__wrap"
      )[0];
      scrollTop.value = bodyWrapper.scrollTop;
    };
    const addScrollEvent = () => {
      let bodyWrapper = tableRef.value.$refs.bodyWrapper.getElementsByClassName(
        "el-scrollbar__wrap"
      )[0];
      bodyWrapper.addEventListener("scroll", scrollFunc);
    };

    onMounted(() => {
      addScrollEvent();
    });

    onActivated(() => {
      addScrollEvent();
      setTimeout(() => {
        nextTick(() => {
          tableRef.value.setScrollTop(scrollTop.value);
        });
      }, 0);
    });
    onDeactivated(() => {
      if (tableRef.value) {
        let bodyWrapper = tableRef.value.$refs.bodyWrapper.getElementsByClassName(
          "el-scrollbar__wrap"
        )[0];
        bodyWrapper.removeEventListener("scroll", scrollFunc);
      }
    });

    return {
      tableRef,
      headerCellStyle,
      slots,
    };

    // return () => (
    //   <el-table
    //     ref="tableRef"
    //     header-cell-style={headerCellStyle}
    //     {...context.attrs}
    //     v-slots={slots}
    //   >
    //     {props.columns.map((item) => {
    //       const { render, ...itemProps } = item;
    //       if (render) {
    //         return (
    //           <el-table-column key={item.prop} row-key="id" {...itemProps}>
    //             {render}
    //           </el-table-column>
    //         );
    //       } else {
    //         return (
    //           <el-table-column key={item.prop} {...itemProps}></el-table-column>
    //         );
    //       }
    //     })}
    //   </el-table>
    // );
  },
  render() {
    return (
      <el-table
        ref="tableRef"
        header-cell-style={this.headerCellStyle}
        row-key="id"
        {...this.$attrs}
        v-slots={this.slots}
      >
        {this.columns.map((item) => {
          const { render, slots, ...itemProps } = item;
          if (render) {
            return (
              <el-table-column
                key={item.prop}
                v-slots={{
                  default: render,
                  ...slots,
                }}
                {...itemProps}
              ></el-table-column>
            );
          } else {
            return (
              <el-table-column
                key={item.prop}
                {...itemProps}
                v-slots={{
                  ...slots,
                }}
              ></el-table-column>
            );
          }
        })}
      </el-table>
    );
  },
});
</script>
